import React from 'react';
import { motion } from 'framer-motion';
import { Gamepad2Icon, UserIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 px-4" data-id="element-154">
      <div className="max-w-6xl mx-auto" data-id="element-155">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-156">
          {/* Teen Pain */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="glass-panel neon-box-green rounded-2xl p-8 relative overflow-hidden group" data-id="element-157">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#39FF14] to-transparent opacity-50" data-id="element-158"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-159">
              <div className="p-3 bg-[#39FF14]/10 rounded-lg text-[#39FF14]" data-id="element-160">
                <Gamepad2Icon size={32} data-id="element-161" />
              </div>
              <h3 className="text-2xl font-bold" data-id="element-162">Si eres un adolescente...</h3>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed" data-id="element-163">
              sabes lo frustrante que es querer comprarse algo épico —esa nueva
              PC, un viaje con amigos o ropa de marca— y darte cuenta de que tu
              cuenta está en <span className="text-red-400 font-bold" data-id="element-164">$0</span>.
              Tienes que volver a pedir permiso a tus padres, dar explicaciones
              y, la mayoría de las veces, recibir un "no". Estás atrapado en la
              dependencia total.
            </p>
          </motion.div>

          {/* Parent Pain */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="glass-panel neon-box-purple rounded-2xl p-8 relative overflow-hidden" data-id="element-165">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#8B5CF6] to-transparent opacity-50" data-id="element-166"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-167">
              <div className="p-3 bg-[#8B5CF6]/10 rounded-lg text-[#8B5CF6]" data-id="element-168">
                <UserIcon size={32} data-id="element-169" />
              </div>
              <h3 className="text-2xl font-bold" data-id="element-170">Si eres un padre...</h3>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed" data-id="element-171">
              el miedo es real: ves a tu hijo gastar impulsivamente y te
              preguntas: "¿Cómo se va a manejar solo en el mundo real?". Tienes
              miedo de que sea un adulto que siga viviendo en tu sofá a los 35
              años porque nunca aprendió a diferenciar entre un deseo y una
              necesidad. El sistema educativo falló en enseñarle esto. Tú no
              tienes que fallar también.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}